module.exports = __webpack_public_path__ + "static/media/training_1.ecb3007f.png";